import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-menu" };
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "input-group-btn" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_12 = { class: "input-group top_search" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_14 = { class: "input-group top_search" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_16 = { class: "input-group top_search" };
const _hoisted_17 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_18 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_19 = { class: "float-end left5" };
const _hoisted_20 = { class: "clearfix pad10" };
const _hoisted_21 = { class: "float-end" };
const _hoisted_22 = {
    key: 0,
    class: "float-end"
};
const _hoisted_23 = { class: "float-end hidden-xs record-count" };
const _hoisted_24 = { class: "col-xs-12 col-sm-12" };
const _hoisted_25 = { class: "card bg-white data-grid comms-grid detached overflow-x-auto" };
const _hoisted_26 = { class: "table table-hover bottom0 pw100" };
const _hoisted_27 = { key: 0 };
const _hoisted_28 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_29 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_30 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_31 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_32 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_33 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_34 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_35 = {
    key: 8,
    class: "hidden-sm"
};
const _hoisted_36 = {
    key: 9,
    class: "hidden-sm"
};
const _hoisted_37 = {
    key: 10,
    class: "hidden-sm"
};
const _hoisted_38 = {
    key: 11,
    class: "hidden-sm"
};
const _hoisted_39 = { key: 0 };
const _hoisted_40 = ["title", "onClick"];
const _hoisted_41 = { class: "system-battery-type" };
const _hoisted_42 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_43 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_44 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_45 = { key: 0 };
const _hoisted_46 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_47 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_48 = { key: 0 };
const _hoisted_49 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_50 = { key: 0 };
const _hoisted_51 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_52 = {
    key: 8,
    class: "hidden-sm"
};
const _hoisted_53 = ["href"];
const _hoisted_54 = {
    key: 9,
    class: "hidden-sm"
};
const _hoisted_55 = {
    key: 10,
    class: "hidden-sm"
};
const _hoisted_56 = {
    key: 11,
    class: "hidden-sm"
};
const _hoisted_57 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_ConnectivityTestModal = _resolveComponent("ConnectivityTestModal");
    const _directive_cloud_only = _resolveDirective("cloud-only");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tComms\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createCommentVNode(" Cloud only: the UDP connectivity test is a check that a Controller can reach the\r\n\t\t\t\t\t hosted Data Collect service, which an on-premise deployment does not use. "),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_b_button, {
                        variant: "secondary",
                        onClick: _ctx.showConnectivityTest
                    }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "fa fa-exchange" }, null, -1 /* CACHED */),
                                _createTextVNode(" Check UDP Connectivity\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])), [
                    [_directive_cloud_only]
                ])
            ])
        ]),
        _cache[56] || (_cache[56] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[11] || (_cache[11] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[15] || (_cache[15] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.companyId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.companyId) = $event)),
                                options: _ctx.companies,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All companies",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _cache[16] || (_cache[16] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.siteId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.siteId) = $event)),
                                options: _ctx.filteredSites,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All sites",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _cache[17] || (_cache[17] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_multiselect, {
                                name: "system",
                                modelValue: _ctx.systemId,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.systemId) = $event)),
                                options: _ctx.filteredSystems,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All systems",
                                class: "multiselect-small",
                                disabled: _ctx.working
                            }, {
                                noResult: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                        ])
                    ])
                ]),
                _cache[52] || (_cache[52] = _createTextVNode()),
                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "clearfix top10" }, null, -1 /* CACHED */)),
                _cache[54] || (_cache[54] = _createTextVNode()),
                (_ctx.searchAttempted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_b_dropdown, {
                                    ref: "columnSettingsDropdown",
                                    "no-caret": "",
                                    end: "",
                                    sm: "",
                                    "auto-close": false,
                                    variant: "outline-secondary outline-secondary-pagination",
                                    disabled: _ctx.working
                                }, {
                                    "button-content": _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                            _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* CACHED */)
                                        ]))]),
                                    default: _withCtx(() => [
                                        _cache[22] || (_cache[22] = _createTextVNode()),
                                        _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                            default: _withCtx(() => [
                                                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clearfix" }, [
                                                    _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ], -1 /* CACHED */)),
                                                _cache[20] || (_cache[20] = _createTextVNode()),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnSettingsList, (column, columnIdx) => {
                                                    return (_openBlock(), _createBlock(_component_b_form_group, {
                                                        key: column.fieldName
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_form_group, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_checkbox, {
                                                                        id: column.fieldName,
                                                                        modelValue: column.visible,
                                                                        "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _cache[23] || (_cache[23] = _createTextVNode()),
                                        _createVNode(_component_b_dropdown_divider),
                                        _cache[24] || (_cache[24] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                                _createVNode(_component_b_button, {
                                                    variant: "secondary",
                                                    right: "",
                                                    sm: "",
                                                    onClick: _ctx.closeColumnSettingsMenu
                                                }, {
                                                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                            _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                            _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"])
                                            ])
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"])
                            ]),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            (_ctx.numberOfVisibleColumns)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_b_pagination, {
                                        class: "float-end",
                                        modelValue: _ctx.query.pageNo,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.pageNo) = $event)),
                                        "per-page": _ctx.query.pageSize,
                                        "total-rows": _ctx.data.recordCount,
                                        "hide-ellipsis": true,
                                        disabled: _ctx.working
                                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[26] || (_cache[26] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_23, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[55] || (_cache[55] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("table", _hoisted_26, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisible('system'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'SystemName', title: 'System' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                    (_ctx.isVisible('site'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_28, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'SiteName', title: 'Site' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                    (_ctx.isVisible('company'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_29, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CompanyName', title: 'Company' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[29] || (_cache[29] = _createTextVNode()),
                                    (_ctx.isVisible('lastComms'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_30, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'WhenLastComms', title: 'Last Comms' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[30] || (_cache[30] = _createTextVNode()),
                                    (_ctx.isVisible('lastCommsSourceId') && _ctx.isPowerShield)
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_31, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'lastCommsSourceId', title: 'Last Comms Source' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[31] || (_cache[31] = _createTextVNode()),
                                    (_ctx.isVisible('latestData'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_32, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'WhenLastDataReceived', title: 'Latest Data' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[32] || (_cache[32] = _createTextVNode()),
                                    (_ctx.isVisible('oldestData'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_33, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'WhenFirstDataReceived', title: 'Oldest Data' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[33] || (_cache[33] = _createTextVNode()),
                                    (_ctx.isVisible('monitor'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_34, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'MonitorFirmwareVersion', title: 'Monitor' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[34] || (_cache[34] = _createTextVNode()),
                                    (_ctx.isVisible('ipAddress') && !_ctx.isCloud)
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_35, "\r\n\t\t\t\t\t\t\t\t\t\tIP Address\r\n\t\t\t\t\t\t\t\t\t"))
                                        : _createCommentVNode("v-if", true),
                                    _cache[35] || (_cache[35] = _createTextVNode()),
                                    (_ctx.isVisible('modem'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_36, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'ModemFirmwareVersion', title: 'Modem' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[36] || (_cache[36] = _createTextVNode()),
                                    (_ctx.isVisible('quality'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_37, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CellularConnectionQuality', title: 'Quality' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[37] || (_cache[37] = _createTextVNode()),
                                    (_ctx.isVisible('signal'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_38, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'LastSignalStrength', title: 'Signal' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _cache[50] || (_cache[50] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        (_ctx.isVisible('system'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_39, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(_ctx.isChemistryDrillDownAllowed(item.batteryTypeId) ? 'pointer blue' : 'link-disabled'),
                                                    title: _ctx.getChemistryDrillDownDisabledReason(item.batteryTypeId) || '',
                                                    onClick: ($event) => (_ctx.goToSnapshot(item.systemId, item.batteryTypeId))
                                                }, [
                                                    _createTextVNode(_toDisplayString(item.systemName) + " ", 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.getBatteryType(item.batteryTypeId)), 1 /* TEXT */)
                                                ], 10 /* CLASS, PROPS */, _hoisted_40)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[38] || (_cache[38] = _createTextVNode()),
                                        (_ctx.isVisible('site'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(item.siteName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[39] || (_cache[39] = _createTextVNode()),
                                        (_ctx.isVisible('company'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(item.companyName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[40] || (_cache[40] = _createTextVNode()),
                                        (_ctx.isVisible('lastComms'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                                                (item.whenLastComms)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.getDateTimeFormatted(item.whenLastComms)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[41] || (_cache[41] = _createTextVNode()),
                                        (_ctx.isVisible('lastCommsSourceId') && _ctx.isPowerShield)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString(_ctx.getLastCommsSource(item.lastCommsSourceId)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[42] || (_cache[42] = _createTextVNode()),
                                        (_ctx.isVisible('latestData'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                                (item.whenLastDataReceived)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.getDateTimeFormatted(item.whenLastDataReceived)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[43] || (_cache[43] = _createTextVNode()),
                                        (_ctx.isVisible('oldestData'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_49, [
                                                (item.whenFirstDataReceived)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.getDateTimeFormatted(item.whenFirstDataReceived)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[44] || (_cache[44] = _createTextVNode()),
                                        (_ctx.isVisible('monitor'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_51, _toDisplayString(item.monitorFirmwareVersion), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[45] || (_cache[45] = _createTextVNode()),
                                        (_ctx.isVisible('ipAddress') && !_ctx.isCloud)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_52, [
                                                (_ctx.isLinkableHost(item.ipAddress))
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: _ctx.toHref(item.ipAddress),
                                                        target: "_blank",
                                                        rel: "noopener noreferrer"
                                                    }, _toDisplayString(item.ipAddress), 9 /* TEXT, PROPS */, _hoisted_53))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(_toDisplayString(item.ipAddress), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[46] || (_cache[46] = _createTextVNode()),
                                        (_ctx.isVisible('modem'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(item.modemFirmwareVersion), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[47] || (_cache[47] = _createTextVNode()),
                                        (_ctx.isVisible('quality'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(item.cellularConnectionQuality), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[48] || (_cache[48] = _createTextVNode()),
                                        (_ctx.isVisible('signal'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(item.lastSignalStrength), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[51] || (_cache[51] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [...(_cache[49] || (_cache[49] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "9"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ]),
        _cache[57] || (_cache[57] = _createTextVNode()),
        _createVNode(_component_ConnectivityTestModal, { ref: "connectivityTestModal" }, null, 512 /* NEED_PATCH */)
    ]));
}
